import { clsx } from 'clsx';

interface PillProps {
  label: string;
  isPrimary?: boolean;
  isActive?: boolean;
}

const Pill = ({ label, isPrimary = false, isActive = false }: PillProps) => {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full border px-3 py-1 text-xs font-light',
        isPrimary &&
          isActive &&
          'border-primary-d-700 bg-primary-d-700 text-white',
        isPrimary &&
          !isActive &&
          'border-gray-d-50 bg-gray-d-50 text-gray-d-600',
        !isPrimary &&
          isActive &&
          'border-[#C5DEDD] bg-[#E8F2F1] text-primary-d-700',
        !isPrimary &&
          !isActive &&
          'border-gray-d-300 bg-gray-d-50 text-gray-d-600',
      )}
    >
      {label}
    </span>
  );
};

export default Pill;
